var _rect, _g, _g2, _g3, _rect2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardLayerCenter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 401,
    height: 232,
    viewBox: "0 0 401 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -2.05613e-8,
    y: 0.344961,
    width: 177.31,
    height: 283.558,
    rx: 13.4535,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 246.873 0.172481)",
    fill: "url(#paint0_linear_1_254)",
    stroke: "url(#paint1_linear_1_254)",
    strokeWidth: 0.689923
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 4.47035e-8,
    y: -0.25,
    width: 19.2897,
    height: 19.2897,
    rx: 9.64486,
    transform: "matrix(-0.866025 -0.5 0.866026 -0.5 155.562 216.496)",
    stroke: "url(#paint2_linear_1_254)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 4.47035e-8,
    y: -0.25,
    width: 19.2897,
    height: 19.2897,
    rx: 9.64486,
    transform: "matrix(-0.866025 -0.5 0.866026 -0.5 145.216 210.522)",
    stroke: "url(#paint3_linear_1_254)",
    strokeWidth: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5872 134.924L44.2634 137.118L43.2596 136.539L46.106 133.662L41.123 135.305L40.1192 134.726L43.9192 131.075L44.8155 131.592L41.5747 134.473L46.8015 132.739L47.7049 133.26L44.7008 136.278L49.691 134.407L50.5872 134.924ZM51.0898 139.793L48.9532 138.559L47.469 138.969L46.5943 138.464L53.4415 136.663L54.3808 137.206L51.2547 141.155L50.38 140.65L51.0898 139.793ZM51.4913 139.296L53.0185 137.446L49.8136 138.327L51.4913 139.296ZM56.7227 141.356L56.3929 144.121L55.3963 143.546L55.7405 141.037L53.3959 142.391L52.5785 141.919L57.6405 138.997L58.4579 139.468L56.142 140.806L60.4654 140.628L61.4549 141.199L56.7227 141.356ZM64.7929 147.415C64.5443 147.558 64.2528 147.657 63.9182 147.713C63.5884 147.765 63.237 147.758 62.8642 147.692C62.4914 147.626 62.1281 147.49 61.7744 147.286C61.4302 147.088 61.1817 146.875 61.0287 146.649C60.8805 146.42 60.8351 146.195 60.8925 145.974C60.9498 145.753 61.11 145.553 61.3729 145.374L62.2476 145.879C62.0516 146.02 61.956 146.182 61.9608 146.367C61.9704 146.555 62.1137 146.729 62.391 146.889C62.6395 147.032 62.8977 147.104 63.1653 147.104C63.4378 147.107 63.6792 147.048 63.8895 146.926C64.0711 146.821 64.1691 146.707 64.1835 146.582C64.2026 146.456 64.1715 146.33 64.0902 146.206C64.009 146.082 63.8823 145.92 63.7102 145.721C63.4951 145.481 63.3374 145.274 63.237 145.101C63.1414 144.929 63.1199 144.749 63.1725 144.558C63.2251 144.368 63.4067 144.183 63.7174 144.004C63.9899 143.846 64.2958 143.747 64.6352 143.706C64.9745 143.664 65.3235 143.683 65.682 143.763C66.0452 143.841 66.3894 143.973 66.7144 144.161C67.2307 144.459 67.5151 144.767 67.5676 145.084C67.625 145.404 67.4744 145.692 67.1159 145.949L66.234 145.44C66.3918 145.31 66.4635 145.164 66.4491 145.001C66.4444 144.838 66.3153 144.684 66.062 144.538C65.8325 144.405 65.5888 144.333 65.3306 144.322C65.0773 144.309 64.8407 144.365 64.6208 144.492C64.4487 144.591 64.3531 144.702 64.334 144.823C64.3197 144.942 64.3508 145.062 64.4272 145.183C64.5133 145.305 64.6399 145.463 64.8072 145.659C65.0271 145.902 65.1849 146.112 65.2804 146.289C65.3856 146.465 65.4095 146.65 65.3521 146.843C65.2996 147.039 65.1132 147.23 64.7929 147.415ZM70.8237 146.608L67.8195 148.342C67.3702 148.602 67.1336 148.851 67.1097 149.092C67.0905 149.334 67.2602 149.559 67.6187 149.766C67.9724 149.971 68.3572 150.066 68.7731 150.052C69.1937 150.041 69.6287 149.906 70.078 149.646L73.0822 147.912L73.8995 148.384L70.8954 150.118C70.2023 150.518 69.4972 150.718 68.7802 150.718C68.068 150.716 67.418 150.545 66.83 150.205C66.2469 149.868 65.9553 149.496 65.9553 149.087C65.9601 148.676 66.309 148.271 67.0021 147.87L70.0063 146.136L70.8237 146.608ZM74.6015 154.634L73.7841 154.162L75.0603 150.586L71.3248 152.742L70.5075 152.27L75.5622 149.352L76.3796 149.824L75.089 153.409L78.8389 151.244L79.6562 151.716L74.6015 154.634ZM80.4233 156.729L78.2867 155.495L76.8025 155.905L75.9278 155.4L82.775 153.599L83.7143 154.141L80.5882 158.09L79.7135 157.585L80.4233 156.729ZM80.8248 156.232L82.352 154.381L79.1471 155.263L80.8248 156.232ZM84.5721 160.391L85.3321 158.495L84.7513 158.159L82.7294 159.327L81.9121 158.855L86.974 155.932L88.7593 156.963C89.3377 157.297 89.634 157.631 89.6484 157.965C89.6675 158.301 89.4452 158.604 88.9816 158.871C88.5848 159.1 88.1475 159.223 87.6695 159.24C87.1963 159.259 86.7135 159.168 86.2212 158.967L85.4898 160.92L84.5721 160.391ZM85.3321 157.824L86.2355 158.346C86.8951 158.726 87.5165 158.749 88.0997 158.412C88.3769 158.252 88.5107 158.081 88.5012 157.899C88.5012 157.716 88.3315 157.527 87.9921 157.331L87.0887 156.81L85.3321 157.824ZM92.7935 159.292L87.7315 162.215L86.9142 161.743L91.9761 158.82L92.7935 159.292Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6816 139.415C29.0044 139.806 28.5882 140.175 28.4328 140.522C28.2775 140.869 28.4746 141.202 29.0243 141.519C29.574 141.836 30.1496 141.95 30.7511 141.86C31.3565 141.773 31.9978 141.534 32.675 141.143C33.3442 140.757 33.7545 140.389 33.9058 140.039C34.0612 139.692 33.864 139.36 33.3143 139.042C32.7646 138.725 32.189 138.611 31.5876 138.701C30.9901 138.788 30.3547 139.026 29.6816 139.415ZM32.1373 140.832C31.7907 141.033 31.474 141.186 31.1872 141.291C30.9084 141.397 30.6296 141.45 30.3508 141.45C30.0719 141.45 29.8011 141.374 29.5382 141.222C29.2793 141.073 29.1498 140.918 29.1498 140.757C29.1498 140.596 29.2394 140.433 29.4187 140.27C29.6059 140.107 29.8728 139.925 30.2193 139.725C30.5619 139.527 30.8726 139.376 31.1514 139.27C31.4342 139.166 31.713 139.116 31.9879 139.118C32.2667 139.118 32.5356 139.193 32.7945 139.342C33.0574 139.494 33.1888 139.65 33.1888 139.811C33.1928 139.97 33.1032 140.13 32.92 140.291C32.7407 140.454 32.4798 140.635 32.1373 140.832ZM36.6857 142.355C36.9048 142.191 37.0123 142.03 37.0083 141.872C37.0123 141.713 36.8928 141.564 36.6499 141.423C36.3113 141.228 35.9229 141.155 35.4847 141.206C35.0506 141.259 34.5487 141.45 33.9791 141.779L33.764 141.91C34.0627 141.806 34.3893 141.776 34.7439 141.82C35.1024 141.861 35.427 141.966 35.7178 142.134C36.136 142.375 36.3372 142.636 36.3212 142.917C36.3093 143.2 36.0783 143.471 35.6281 143.731C35.3652 143.883 35.0745 143.991 34.7558 144.055C34.4411 144.117 34.1125 144.123 33.7699 144.073C33.4354 144.022 33.1107 143.906 32.796 143.724C32.1946 143.377 31.9695 143.028 32.1209 142.679C32.2762 142.332 32.6785 141.971 33.3278 141.596C34.0767 141.163 34.7578 140.908 35.3712 140.83C35.9926 140.752 36.5762 140.87 37.1219 141.185C37.5242 141.418 37.7194 141.661 37.7074 141.917C37.6994 142.174 37.5321 142.42 37.2055 142.655L36.6857 142.355ZM33.2681 142.265C32.9773 142.433 32.816 142.623 32.7841 142.834C32.7602 143.046 32.9175 143.249 33.2561 143.445C33.5349 143.606 33.8397 143.687 34.1703 143.69C34.5049 143.69 34.8215 143.603 35.1203 143.431C35.4429 143.245 35.6042 143.055 35.6042 142.862C35.6082 142.666 35.4628 142.483 35.1681 142.313C35.0008 142.217 34.8076 142.144 34.5885 142.096C34.3694 142.048 34.1424 142.036 33.9074 142.061C33.6763 142.084 33.4632 142.152 33.2681 142.265ZM42.4222 142.734L34.135 145.629L33.6092 145.325L41.8904 142.427L42.4222 142.734ZM37.4872 145.901C38.6184 146.03 39.6103 146.083 40.4627 146.06C41.3191 146.035 41.9405 145.911 42.3269 145.687C42.5658 145.549 42.6953 145.403 42.7152 145.249C42.7431 145.095 42.6216 144.94 42.3508 144.784C42.0719 144.623 41.7712 144.553 41.4485 144.573C41.1299 144.592 40.8072 144.686 40.4806 144.856L39.9429 144.546C40.4408 144.29 40.9466 144.166 41.4605 144.173C41.9783 144.178 42.4444 144.3 42.8586 144.539C43.253 144.766 43.4601 145.008 43.48 145.263C43.4999 145.518 43.3167 145.758 42.9303 145.981C42.6117 146.165 42.1835 146.292 41.6457 146.364C41.1159 146.435 40.5543 146.462 39.9608 146.446C39.3752 146.43 38.8216 146.384 38.2998 146.308L40.4388 147.543L39.9907 147.802L37.0928 146.129L37.4872 145.901ZM42.6817 146.92C42.0045 147.311 41.5883 147.68 41.4329 148.028C41.2776 148.375 41.4747 148.707 42.0244 149.025C42.5741 149.342 43.1497 149.456 43.7512 149.366C44.3566 149.279 44.9979 149.04 45.6751 148.649C46.3443 148.262 46.7546 147.894 46.9059 147.545C47.0613 147.197 46.8641 146.865 46.3144 146.548C45.7647 146.23 45.1891 146.117 44.5877 146.206C43.9902 146.294 43.3548 146.532 42.6817 146.92ZM45.1373 148.338C44.7908 148.538 44.4741 148.691 44.1873 148.797C43.9085 148.903 43.6297 148.956 43.3508 148.956C43.072 148.956 42.8012 148.88 42.5383 148.728C42.2793 148.578 42.1499 148.423 42.1499 148.262C42.1499 148.101 42.2395 147.939 42.4188 147.776C42.606 147.613 42.8729 147.431 43.2194 147.231C43.562 147.033 43.8727 146.881 44.1515 146.775C44.4343 146.672 44.7131 146.621 44.988 146.624C45.2668 146.624 45.5357 146.698 45.7946 146.848C46.0575 147 46.1889 147.156 46.1889 147.317C46.1929 147.476 46.1033 147.636 45.9201 147.797C45.7408 147.96 45.4799 148.14 45.1373 148.338ZM44.5474 149.978C45.6786 150.106 46.6705 150.159 47.5229 150.136C48.3793 150.111 49.0007 149.987 49.387 149.764C49.626 149.626 49.7555 149.48 49.7754 149.326C49.8033 149.171 49.6818 149.016 49.4109 148.86C49.1321 148.699 48.8314 148.629 48.5087 148.649C48.1901 148.668 47.8674 148.762 47.5408 148.932L47.0031 148.622C47.501 148.367 48.0068 148.242 48.5207 148.249C49.0385 148.254 49.5045 148.376 49.9188 148.615C50.3132 148.843 50.5203 149.084 50.5402 149.339C50.5601 149.595 50.3769 149.834 49.9905 150.057C49.6718 150.241 49.2436 150.369 48.7059 150.44C48.1761 150.511 47.6145 150.539 47.021 150.523C46.4354 150.506 45.8818 150.46 45.36 150.385L47.499 151.62L47.0509 151.878L44.153 150.205L44.5474 149.978ZM48.4214 151.579L48.8755 151.317L53.8586 150.938L54.4441 151.276L51.6419 152.894L52.2633 153.253L51.7912 153.525L51.1699 153.166L50.2019 153.725L49.6522 153.408L50.6202 152.849L48.4214 151.579ZM53.267 151.362L49.467 151.638L51.128 152.597L53.267 151.362Z",
    fill: "white",
    fillOpacity: 0.7,
    shapeRendering: "crispEdges"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.5,
    width: 23.8605,
    height: 18.0421,
    rx: 1.5,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 148.039 133.822)",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.403 153.599C135.205 153.439 132.741 152.763 132.47 151.333M134.777 156.164C132.919 155.889 128.966 154.726 128.018 152.269M133.559 158.566C131.084 158.174 125.714 156.529 124.034 153.078M131.826 160.91C128.811 160.499 122.218 158.557 119.966 154.076",
    stroke: "white",
    strokeWidth: 1.37985,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_254",
    x: 37.8071,
    y: 131.037,
    width: 56.0509,
    height: 33.2063,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_254"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_254",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_254",
    x: 25.5269,
    y: 137.397,
    width: 31.9248,
    height: 19.2771,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_254"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_254",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_254",
    x1: 0,
    y1: 0,
    x2: 178,
    y2: 284.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_254",
    x1: -0.00000121225,
    y1: 9.5,
    x2: 167.5,
    y2: 284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_254",
    x1: 9.89486,
    y1: 0,
    x2: 9.89486,
    y2: 19.7897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_254",
    x1: 9.89486,
    y1: 0,
    x2: 9.89486,
    y2: 19.7897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardLayerCenter);
export default __webpack_public_path__ + "static/media/card-layer-center.b99a714d8caedab84081b23173c9705c.svg";
export { ForwardRef as ReactComponent };